import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import Routes from 'consts/routes';
import { BoxWrapper } from 'components/Base';
import Icons from 'components/Icons';
import LinkCard from './LinkCard';
import {
  DevicesRounded as DevicesRoundedIcon,
  TimelineRounded as TimelineRoundedIcon
} from '@material-ui/icons';
import api from 'api';
import moment from 'moment';
import { useTheme } from '@material-ui/styles';

const InvestmentPropositionTile = () => {
  const theme = useTheme() as any;
  const history = useHistory();
  const [activities, setActivities] = useState({
    platform: null,
    investment: null,
    'risk-mapping': null
  });

  useEffect(() => {
    api.getInvestmentPropositionActivities().then(({ data }) => {
      setActivities(data);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <BoxWrapper
      title={
        <div style={{ display: 'flex', alignItems: 'center' }}>
          Manage Investment Proposition
        </div>
      }
      noBorder
      style={{ overflow: 'hidden' }}
    >
      <div style={{ height: '100%' }}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            height: '100%'
          }}
        >
          <LinkCard
            title="Platform/Product selection"
            icon={
              <DevicesRoundedIcon
                style={{
                  fontSize: 48,
                  color: theme.palette.baseColors.secondary
                }}
              />
            }
            onClick={() => history.push(Routes.PROVIDER_PLATFORM_CHARGES)}
          >
            {activities.platform && (
              <div>
                Last updated <b>{moment(activities.platform).fromNow()}</b>
              </div>
            )}
          </LinkCard>
          <LinkCard
            title="Investment selection"
            icon={
              <Icons.BarTrendUp
                width={'48px'}
                style={{ fill: theme.palette.baseColors.secondary }}
              />
            }
            onClick={() => history.push(Routes.CIP_MANAGEMENT)}
          >
            {activities.investment && (
              <div>
                Last updated <b>{moment(activities.investment).fromNow()}</b>
              </div>
            )}
          </LinkCard>
          <LinkCard
            title="Risk mapping"
            icon={
              <TimelineRoundedIcon
                style={{
                  fontSize: 48,
                  color: theme.palette.baseColors.secondary
                }}
              />
            }
            onClick={() => history.push(Routes.RISK_MAPPING)}
          >
            {activities['risk-mapping'] && (
              <div>
                Last updated{' '}
                <b>{moment(activities['risk-mapping']).fromNow()}</b>
              </div>
            )}
          </LinkCard>
        </div>
      </div>
    </BoxWrapper>
  );
};

export default InvestmentPropositionTile;
